import apps from "./apps";
import buttonWidget from "./button";
import dashboard from "./dashboard";
import instagram, { instagramReel } from "./instagram";
import { IMenuItems } from "./MenuModel";
import pricing from "./pricing";
import tikTok from "./tiktok";
export default class MenuManagement {
  public static items: IMenuItems[] = [
    dashboard,
    tikTok,
    instagram,
    buttonWidget,
    instagramReel,
    pricing,
    apps
  ]
}
